import React, { Component } from 'react'
import IconInfoBlue from '../../assets/icons/IconInfoBlue'
import styles from './UnitInput.module.css'

export default class UnitInput extends Component {
    constructor(props) {
        super(props)

        this.infoRef = React.createRef()
        this.infoContainerRef = React.createRef()
        this.state = {
            isFocused: false,
            isShowInfo: false,
            infoPosition: {
                top: 0,
                right: 0
            }
        }
    }
    
    componentDidMount() {
        this.infoContainerRef.current.addEventListener('mouseover', this.showInfo)
        this.infoContainerRef.current.addEventListener('mouseleave', this.hideInfo)
    }

    showInfo = () => {
        this.setInfoPosition()

        this.setState({
            isShowInfo: true
        })
    }

    hideInfo = () => {
        this.setState({
            isShowInfo: false
        })
    }

    componentWillUnmount() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect()
        }

        if (this.infoContainerRef) {
            this.infoContainerRef.current.removeEventListener('mouseover', this.showInfo)
            this.infoContainerRef.current.removeEventListener('mouseleave', this.hideInfo)
        }
    }

    setInfoPosition = () => {
        if (!this.infoContainerRef.current || !this.infoRef.current) {
            return
        }

        const iconRect = this.infoContainerRef.current.getBoundingClientRect()
        const infoRect = this.infoRef.current.getBoundingClientRect()

        this.setState({
            infoPosition: {
                top: `${iconRect.top - infoRect.height}px`,
                left: `${iconRect.left - infoRect.width + iconRect.width}px`
            }
        })
    }

    handleChange = (e) => {
        if (this.props.onChange) {
            this.props.onChange(e)
        }
    }

    isError = () => {
        if (this.props.errorMessage) {
            return true
        }

        return false
    }

    showErrorMessage = () => {
        if (!this.props.errorMessage) {
            return null
        }

        return <div className="error-message text-sm text-red-500 mt-1">{this.props.errorMessage}</div>
    }

    render() {
        return (
            <div className={`unit-input ${this.props.className || ''}`}>
                <div className="flex justify-between items-center">
                    <label className="inline-block font-medium mb-1" htmlFor={this.props.id}>{this.props.label}</label>
                    {
                        this.props.info && 
                            <div className="info z-10" ref={this.infoContainerRef}>
                                <IconInfoBlue className={styles['info-icon']} width={20} height={24} />
                                <div 
                                    className={`${styles['info-text']} ${this.state.isShowInfo ? styles['info-text-show'] : ''} text-sm italic absolute bottom-full w-96 px-6 py-3 rounded-md shadow-md bg-white-7`} 
                                    ref={this.infoRef}
                                    style={this.state.infoPosition}
                                >
                                    <span className="font-bold">Note :</span>
                                    <br />
                                    {this.props.info}
                                </div>
                            </div>
                    }
                </div>
                <div className={`flex items-center w-full rounded-md ${styles['input']} ${this.isError() ? styles['input-error'] : ''} ${!this.isError() && this.state.isFocused ? styles['input-focus'] : ''} overflow-hidden`}>
                    <input 
                        id={this.props.id}
                        className="w-full outline-none px-3 py-3"
                        type="text" 
                        placeholder={this.props.placeholder}
                        onFocus={() => this.setState({ 
                            isFocused: true
                        })}
                        onBlur={() => this.setState({ 
                            isFocused: false
                        })}
                        value={this.props.value}
                        name={this.props.name}
                        onChange={this.handleChange}
                        min={this.props.min}
                        max={this.props.max}
                    />
                    <div className="unit select-none pr-3">{this.props.unit}</div>
                </div>
                {this.showErrorMessage()}
            </div>
        )
    }
}
